import { useEffect, useState } from 'react'
import style from './Main.module.css'
import FeedCard from '../../feed/FeedCard'
import { useNavigate } from 'react-router-dom'
import { transformEvents } from '../../../../utils/FeedTransformData'

const API_URL = process.env.REACT_APP_API_URL || ''

const Events = ({ selectedProfile, setSelectedTab }) => {
  const [selectedFilter, setFilter] = useState('All')
  const navigate = useNavigate()
  const filtersPersonal = ['All', 'Near Me', 'Upcomming', 'Online', 'Saved']
  const filtersMentor = ['All', 'Online', 'Upcomming', 'Over']
  const [eventData, setEventData] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [eventsData] = await Promise.all([
          fetch(`${API_URL}/feed/events`).then((res) => res.json()),
        ])

        const transformedEvents = transformEvents(eventsData)

        setEventData([...transformedEvents])
      } catch (error) {
        console.error('Error fetching or transforming data:', error)
      }
    }

    fetchData()
  }, [])

  const toggleFilter = (value) => {
    setFilter(value)
  }
  return (
    <div className={style.eventsContainer}>
      <p className={style.title}>Events</p>
      <div className={style.filterContainer}>
        <div style={{ display: 'flex', gap: '10px' }}>
          {selectedProfile === 'Personal'
            ? filtersPersonal.map((filter, index) => (
                <div
                  key={index}
                  className={`${
                    selectedFilter === filter
                      ? style.selectedFilter
                      : style.filter
                  }`}
                  onClick={() => toggleFilter(filter)}
                >
                  {filter}
                </div>
              ))
            : filtersMentor.map((filter, index) => (
                <div
                  key={index}
                  className={`${
                    selectedFilter === filter
                      ? style.selectedFilter
                      : style.filter
                  }`}
                  onClick={() => toggleFilter(filter)}
                >
                  {filter}
                </div>
              ))}
        </div>
        {selectedProfile === 'Mentor' && (
          <div className={style.newEvent}>
            Create a New Event
            <div
              className={style.plus}
              onClick={() => {
                navigate('create-new-event')
                setSelectedTab('Connect')
              }}
            >
              +
            </div>
          </div>
        )}{' '}
      </div>
      <div className={style.cardsContainer}>
        {eventData.map((feedItem, index) => {
          return (
            <FeedCard
              key={index}
              feedItem={feedItem}
              index={index}
              events={true}
            />
          )
        })}
      </div>
      <p className={style.scrollText}>Scroll to see more</p>
    </div>
  )
}
export default Events
